export default __webpack_public_path__ + "static/media/nft4.fb555e5d.png";